export enum COOKIE_NAME {
  WATCHED_AD_IDS = 'WATCHED_AD_IDS'
}
